// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"8a11ce2d","916":"013411d6"}[chunkId] + ".chunk.css";
};